export const NEEDL_LINKS = {
  DEMO_LINK:
    "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ09P2Y_Rk7rV8-LxlgodEsmF4ljYLTyeABqX6YoQwen5y0mKsWkR1VFEmUmLOPlA0_ueYH-Chhl",
  SECURITY_PAGE: "https://www.needl.ai/security",
  TERMS_OF_SERVICE: "https://www.needl.ai/terms-of-service",
  PRIVACY_POLICY: "https://www.needl.ai/privacy-policy",
};
